module.exports = __webpack_public_path__ + "img/newsCategories.534ae94b.svg";